/**
 * Format large numbers with abbreviations for incremental game display.
 * Examples: 742, 23.5K, 1.2M, 3.7B, 1.5T
 */
export function formatNumber(n: number): string {
  if (n < 0) return '-' + formatNumber(-n);
  if (n < 1000) return Math.floor(n).toString();
  if (n < 1_000_000) {
    const k = n / 1000;
    return k < 10 ? k.toFixed(1) + 'K' : Math.floor(k) + 'K';
  }
  if (n < 1_000_000_000) {
    const m = n / 1_000_000;
    return m < 10 ? m.toFixed(1) + 'M' : Math.floor(m) + 'M';
  }
  if (n < 1_000_000_000_000) {
    const b = n / 1_000_000_000;
    return b < 10 ? b.toFixed(1) + 'B' : Math.floor(b) + 'B';
  }
  const t = n / 1_000_000_000_000;
  return t < 10 ? t.toFixed(1) + 'T' : Math.floor(t) + 'T';
}
